import React, { Component } from 'react'
import IdleTimer from "react-idle-timer"
import { TimeoutModal } from './TimeoutModal'
import { AUTH_CLIENT_ID } from 'constants/ResourcesConstants'
import { Div } from '@driftt/tide-core-legacy'
import { removeAccessTokenExpiration, decreaseOpenTabCount, increaseOpenTabCount, redirectToLoginPage } from '@driftt/web-auth'
import withTracking from 'components/hocs/withTracking'

const SESSION_TIMEOUT_MODAL_TIME = 120000

class IdleTimeout extends Component{
  constructor(props){
    super(props)
    this.state = {
      sessionLength: 0,
      timeoutEnabled: false,
      isIdle: false
    }
  }

  tabCloseHandler = () => decreaseOpenTabCount({ tokenExpirationInMillis: this.state.sessionLength })

  componentDidMount() {
    increaseOpenTabCount()
    window.addEventListener("beforeunload", this.tabCloseHandler)
  }

  componentWillUnmount () {
    window.removeEventListener("beforeunload", this.tabCloseHandler)
  }

  componentDidUpdate(prevProps){
    if (prevProps.sessionLengthMillis != this.props.sessionLengthMillis){
      this.applySessionTimeoutSettings(this.props.sessionLengthMillis) 
    }
  }

  applySessionTimeoutSettings = (data) => {
    if (data > 0){
      this.setState({
        timeoutEnabled: true,
        sessionLength: data
      })
      removeAccessTokenExpiration()
    }
  }

  onIdle = () => {
    this.setState({
      isIdle: true
    })
  }

  onContinue = () => {
    this.setState({
      isIdle: false
    })
  }

  onLogOut = (showTimeoutBanner) => {
    this.props.track("User session timed out")
    redirectToLoginPage(AUTH_CLIENT_ID, showTimeoutBanner)
  }

  render () {
    const { children } = this.props
    const { timeoutEnabled, sessionLength } = this.state
    return (
      <Div>
        {timeoutEnabled ?  
          <Div>
            <IdleTimer onIdle={this.onIdle} timeout={sessionLength - SESSION_TIMEOUT_MODAL_TIME}/>
              <Div>
                <Div>{children}</Div>
                  {this.state.isIdle && 
                    <TimeoutModal
                      cancel={this.onContinue}
                      logOut={this.onLogOut}
                      modalTime={SESSION_TIMEOUT_MODAL_TIME}/>
                  }
              </Div>
          </Div>
          :
          <Div>
            <Div></Div>
            <Div>
              <Div>{children}</Div>
            </Div>
          </Div>
        }
      </Div>
    )
  } 
}

export default withTracking(IdleTimeout)



// WEBPACK FOOTER //
// ./src/scripts/components/IdleTimeout/index.js